var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCrescoLogoIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 369",
    style: {
      enableBackground: "new 0 0 500 369"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "flower",
    className: "st0",
    d: "M165.2,252.5h169.3v-12.8h-57.9l56.2-28.9l-5.8-11.4L265.5,231l37.4-54.4l-10.5-7.3l-36,52.4 v-70.3h-12.8v70.2l-35.8-52.4l-10.6,7.2l37.2,54.4L173,199.4l-5.9,11.4l56,28.9h-57.9L165.2,252.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "line-bottom",
    className: "st0",
    d: "M250.1,293.4c-84.3,0-165.6,22.4-228.9,63.2l-2.7,1.8l7.1,10.7l2.7-1.7 c61.2-39.4,139.9-61.1,221.8-61.1c81.5,0,159.9,21.5,221,60.6l2.7,1.7l7-10.7l-2.7-1.8C415,315.6,334,293.4,250.1,293.4 L250.1,293.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "line-one",
    className: "st0",
    d: "M250,0C112.1,0,0,112.1,0,250c0,25.4,3.8,50.4,11.3,74.5l1.2,3.7l3.4-1.8c1.9-1,3.8-2,5.7-3.1 l2.4-1.2l-0.8-2.5c-6.9-22.5-10.4-45.9-10.4-69.6C12.8,119.2,119.2,12.8,250,12.8S487.2,119.2,487.2,250c0,23.6-3.5,47-10.4,69.6 l-0.8,2.6l2.4,1.2c1.9,1,3.8,2,5.7,3l3.4,1.9l1.2-3.7c7.5-24.1,11.4-49.2,11.4-74.5C500,112.1,387.9,0,250,0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "line-two",
    className: "st0",
    d: "M429.7,301.9l2.8,1c2,0.7,4,1.5,5.9,2.3l3.3,1.3l1-3.4c5.5-18.5,8.2-37.7,8.2-57.1 c0-110.8-90.1-200.9-200.9-200.9c-110.8,0-200.9,90.1-200.9,200.9c0,19.4,2.8,38.6,8.3,57.1l1,3.4l3.3-1.3c2-0.8,3.9-1.5,5.9-2.3 l2.8-1l-0.8-2.9c-5-17.2-7.6-35-7.6-53C61.9,142.4,146.3,58,250,58s188.1,84.4,188.1,188.1c0,18-2.6,35.8-7.6,53L429.7,301.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "line-three",
    className: "st0",
    d: "M382,285.5l12.3,3.7l0.9-3.2c3.5-12.9,5.3-26.4,5.3-40c0-83-67.5-150.5-150.5-150.5 c-83,0-150.5,67.5-150.5,150.5c0,13.9,1.9,27.6,5.6,40.8l0.9,3.2l12.3-3.8l-0.8-3c-3.4-12.1-5.1-24.6-5.1-37.2 c0-75.9,61.8-137.7,137.7-137.7s137.7,61.8,137.7,137.7c0,12.3-1.6,24.6-4.9,36.4L382,285.5z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrescoLogoIcon);
export default __webpack_public_path__ + "static/media/cresco-logo-icon.409b063d4fbf7f4c00d2637f345b928e.svg";
export { ForwardRef as ReactComponent };